exports.viewport = {
  'large': [ '>', 1080, 'px' ],
  'medium': [ '<=', 1080, 'px' ],
  'small': [ '<=', 700, 'px' ],
};
